//import CrearActualizar from "./CrearActualizar";
//import Listar from "./Listar";
//
//export default { CrearActualizar, Listar };

export { default as Listado } from "./Listar";
export { default as CrearActualizar } from "./CrearActualizar";
